import { createAction } from '@reduxjs/toolkit';
import type { IErrorType } from '../../constants/types';
import type { IContentCategoryCatalog } from '../../utils/contentCategoriesApi';
import { types, type IFetchContentCategoriesPayload } from './types';

export const fetchContentCategories = createAction<IFetchContentCategoriesPayload>(types.FETCH);
export const fetchContentCategoriesSuccess = createAction<IContentCategoryCatalog>(types.FETCH_SUCCESS);
export const fetchContentCategoriesFail = createAction<IErrorType>(types.FETCH_FAIL);
export const clearContentCategories = createAction(types.CLEAR);
